module.exports = __webpack_public_path__ + "img/align-left.44048ee2.svg";